import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=85825108&scoped=true&"
import script from "./CalendarItem.vue?vue&type=script&lang=js&"
export * from "./CalendarItem.vue?vue&type=script&lang=js&"
import style0 from "./CalendarItem.vue?vue&type=style&index=0&id=85825108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85825108",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/CalendarItem.vue
// module id = null
// module chunks = 